/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/naming-convention */
declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        UdeskApiObject: string
        ud: ((...args: any[]) => any) & { d: any[] }
    }
}

import sha1 from 'crypto-js/sha1'

import { NTW_TYPE, NTW_VERSION } from '@/constants'

/**
 *  产生一定长度的随机字符串
 */
export function randomString(len = 32) {
    const chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    const maxPos = chars.length
    let pwd = ''
    for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
}

function findSelector(selector: string, type: 'id' | 'className', element: HTMLElement): boolean {
    if (element[type] === selector) {
        return true
    }
    if (element.parentElement) {
        return findSelector(selector, type, element.parentElement)
    }
    return false
}

const IM_CUSTOMER_KEY = 'c189f90142aaeb0adf26a20f81fcb30d'
const CS_CONFIG: Partial<Record<
    keyof typeof NTW_VERSION,
    {
        link: string
        groupId: number
        webPluginId: number
    }
>> = {
    scrm: {
        link: 'https://1390767.s4.udesk.cn/im_client/?web_plugin_id=26591&group_id=27933',
        groupId: 27933,
        webPluginId: 26591
    },
    basic: {
        link: 'https://1390767.s4.udesk.cn/im_client/?web_plugin_id=26549&group_id=27931&language=zh-cn',
        groupId: 27931,
        webPluginId: 26549
    },
    mkt: {
        link: 'https://1390767.s4.udesk.cn/im_client/?web_plugin_id=26550&group_id=27932&language=zh-cn',
        groupId: 27932,
        webPluginId: 26550
    }
}

export const openGlobalCustomerService = () => {
    const eventDiv = document.querySelector('#dingdan-global-customer-service')
    eventDiv?.dispatchEvent(new Event('click'))
}

export const initGlobalCustomerService = () => {
    let networkInfo: Record<string, any> = {}
    try {
        const localInfo = localStorage.getItem('networkInfo')
        localInfo && (networkInfo = JSON.parse(localInfo))
    } catch (error) {
        console.warn('未查询到网络信息')
    }
    const { name, ntwNum, type, finalVersion, versionList } = networkInfo
    const version = (finalVersion as keyof typeof NTW_VERSION) || 'basic'
    const { link, groupId } = CS_CONFIG[version] || CS_CONFIG.basic!
    window.UdeskApiObject = 'ud'
    window.ud =
        window.ud ||
        function() {
            // eslint-disable-next-line prefer-rest-params
            (window.ud.d = window.ud.d || []).push(arguments)
        }
    if (!document.querySelector('#dingdan-global-customer-service')) {
        const eventDiv = document.createElement('div')
        eventDiv.id = 'dingdan-global-customer-service'
        document.body.appendChild(eventDiv)
    }

    const timestamp = Date.now()
    const nonce = randomString()
    const web_token = localStorage.getItem('token')
    if (!web_token) {
        return
    }

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://assets-cli.s4.udesk.cn/im_client/js/udeskApi.js'
    const tag = document.getElementsByTagName('script')[0]
    tag && tag.parentNode && tag.parentNode.insertBefore(script, tag)

    const nickName = localStorage.getItem('name')
    const phone = localStorage.getItem('phone')
    const avatar = localStorage.getItem('avatar')
    window.ud({
        code: '1684fc8a',
        panel: {
            css: {
                right: 0
            }
        },
        link,
        isInvite: true,
        group_id: groupId,
        mode: 'inner',
        language: 'zh-cn',
        onlineText: '您好，订单来了为您服务！',
        offlineText: '当前无客服在线，请在工作日9:00至21:00点联系客服',
        targetSelector: '#dingdan-global-customer-service',
        selector: '.dingdan-global-customer-service,.zhiCustomBtn',
        merchant_name: name + '-' + nickName,
        merchant_avatar: avatar,
        customer: {
            c_name: nickName,
            c_phone: phone,
            c_cf_网络名称: name,
            c_cf_网络号: ntwNum,
            c_cf_客户昵称: nickName,
            c_cf_系统: '新系统web',
            c_cf_网络类型: NTW_TYPE[type as keyof typeof NTW_TYPE || 1],
            c_cf_网络版本: versionList?.find((item: { identify: string }) => item.identify === version)?.versionName || '-',
            c_cf_老系统网络版本: '无',
            timestamp,
            nonce,
            signature: sha1(`nonce=${nonce}&timestamp=${timestamp}&web_token=${web_token}&${IM_CUSTOMER_KEY}`)
                .toString()
                .toUpperCase(),
            web_token,
            customer_token: web_token,
        }
    })
}
